'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketEditionPopinController", function ($scope, $http, $q, lovService, $notifications, $session, $applications) {
  var isEdit = $scope.edit;
  var originalTicket = isEdit || $scope.ticket != null ? $scope.ticket : {
    documents: [],
    visibleClient: true,
    statutTicket: 'A_TRAITER',
    dateDebutTicket: moment().toDate(),
    watcherIds: [],
    echanges: [{
      'type': 'DEMANDE',
      message: null,
      edit: true
    }],
    subvention: $applications.isAideSubventionApplication()
  };
  var ticket = $scope.ticket = angular.copy(originalTicket);
  $scope.originalTicket = angular.copy(originalTicket);
  $scope.ajouterReponse = function () {
    $scope.ticket.echanges.push({
      type: 'REPONSE',
      message: null,
      date: null,
      edit: true
    });
  };
  $scope.ajouterDemande = function () {
    $scope.ticket.echanges.push({
      type: 'DEMANDE',
      message: null,
      date: null,
      edit: true
    });
  };

  // on ajoute un champ de réponse automatiquement sur réédition qui sera retiré si vide à la sauvegarde
  if (isEdit) {
    $scope.ajouterReponse();
  }
  if ($scope.ticket.watcherIds == null) {
    $scope.ticket.watcherIds = [];
  }
  $scope.params = {};
  $q.when(lovService.getTaskStatuts()).then(function (lov) {
    $scope.taskStatuts = lov;
  });
  $q.when(lovService.getTypeTickets()).then(function (lov) {
    $scope.typeTickets = lov;
  });
  $http.get('/rest/echange/assignableUsers').then(function (response) {
    $scope.users = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: user.prenom + " " + user.nom
      };
    });
  });
  $http.get('/rest/echange/demandeurs', {
    params: {
      compteId: ticket.compteId
    }
  }).then(function (response) {
    $scope.demandeurs = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: (user.prenom != null ? user.prenom + " " : "") + user.nom + (user.actif ? "" : " (désactivé)"),
        actif: user.actif
      };
    });
  });
  $scope.renderUser = function (userId) {
    if ($scope.demandeurs) {
      var ts = _.find($scope.demandeurs, {
        id: userId
      });
      if (ts) {
        var label = ts.label;
        if (!ts.actif) {
          label += " (désactivé)";
        }
        return label;
      }
      return "[" + userId + "]";
    }
  };

  /**
   *
   * uniquementles utilisateurs actifs
   */
  $scope.watcherList = function () {
    return _.filter($scope.demandeurs, function (d) {
      return d.actif && d.id !== $scope.ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watcherIds, d.id) === -1;
    });
  };
  $scope.removeWatcher = function (id) {
    var index = _.indexOf($scope.ticket.watcherIds, id);
    $scope.ticket.watcherIds.splice(index, 1);
  };
  $scope.addWatcher = function () {
    var watcherId = $scope.params.newWatcherId;

    // si non deja présent dans la liste on l'ajoute
    if (watcherId != null && watcherId !== ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watchersId, watcherId) === -1) {
      if ($scope.ticket.watcherIds == null) {
        $scope.ticket.watcherIds = [];
      }
      $scope.ticket.watcherIds.push(watcherId);
    }
    $scope.params.newWatcherId = null;
  };
  $scope.genereraNotificationMail = function () {
    // si il y a un demandeur d'indiqué et qu'on est sur une creation ou que le statut a changé.
    return $scope.ticket.demandeurUtilisateurId != null && ticket.visibleClient && (ticket.envoieMailForce || $scope.edit === false || $scope.ticket.statutTicket !== $scope.originalTicket.statutTicket);
  };
  $scope.dateFinAujourdhui = function () {
    $scope.ticket.dateFinTicket = new Date();
  };
  $scope.traiteParMoi = function () {
    $scope.ticket.idAttribution = $session.getUser().id;
  };
  $scope.ticketFormConfig = {
    url: function url() {
      return '/rest/echange/ticket/' + (isEdit && ticket.id || "");
    },
    data: function data() {
      return ticket;
    },
    customValidation: function customValidation() {
      var errors = [];
      return errors;
    },
    fieldPrefix: "ticket.",
    fields: {
      titre: {
        mandatory: true
      },
      typeTicket: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(savedTicket) {
      _.extend(ticket, savedTicket);
      $notifications.info("Ticket enregistré");
      $scope.$close(ticket);
    },
    onError: function onError(errors) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/editionConsultant/ticketEditionPopinController.js
// module id = 2892
// module chunks = 13